import { Controller } from '@hotwired/stimulus';
import { Helpers } from '../helpers';

export default class extends Controller {
  static targets = [
    'field',
    'input',
    'results'
  ];
  static values = { url: String }

  connect() {
    this.timeout = null
  }

  search(event) {
    this.preventSubmit(event);
    clearTimeout(this.timeout)

    const query = this.sanitizeQuery(this.inputTarget.value)

    if (query.length < 2) {
      this.resultsTarget.classList.add('d-none')
      return
    }

    this.timeout = setTimeout(() => {
      this.fetchResults(query)
    }, 1000)
  }

  async fetchResults(query) {
    const url = `${this.urlValue}?q=${encodeURIComponent(query)}`

    try {
      const response = await fetch(url, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      const html = await response.text()
      this.resultsTarget.innerHTML = html
      this.resultsTarget.classList.remove('d-none')
    } catch (error) {
      console.error('Erreur autocomplete:', error)
    }
  }

  selectResult(event) {
    const companyNameValue = Helpers.capitalize(event.currentTarget.dataset.companyNameValue);
    const registrationNumberValue = event.currentTarget.dataset.registrationNumberValue
    const creationDateValue = event.currentTarget.dataset.creationDateValue
    const streetValue = Helpers.capitalize(event.currentTarget.dataset.streetValue);
    const zipCodeValue = event.currentTarget.dataset.zipCodeValue
    const cityValue = Helpers.capitalize(event.currentTarget.dataset.cityValue);
    const countryValue = event.currentTarget.dataset.countryValue

    this.inputTarget.value = companyNameValue;

    this.fieldTargets.forEach((target) => {
      const type = target.dataset.pappersAutocompleteType;

      switch (type) {
        case 'registration_number':
          target.value = registrationNumberValue;
          break;
        case 'company_name':
          target.value = companyNameValue;
          break;
        case 'creation_date':
          target.value = creationDateValue;
          break;
        case 'street':
          target.value = streetValue;
          break;
        case 'zip_code':
          target.value = zipCodeValue;
          break;
        case 'city':
          target.value = cityValue;
          break;
        case 'country':
          target.tomselect.setValue(countryValue);
          break;
      }
    });

    this.resultsTarget.classList.add('d-none')
  }

  closeResults() {
    setTimeout(() => {
      this.resultsTarget.classList.add('d-none')
    }, 200)
  }

  reopenResults() {
    const query = this.sanitizeQuery(this.inputTarget.value)

    if (query.length >= 2 && this.resultsTarget.innerHTML.trim() !== '') {
      this.resultsTarget.classList.remove('d-none')
    }
  }

  preventSubmit(event) {
    if (event.code === 'Enter') {
      event.preventDefault();
    }
  }

  sanitizeQuery(value) {
    let query = value.trim()

    // remove spaces for numeric queries (siren/siret)
    if (/^[\d\s]+$/.test(query)) {
      query = query.replace(/\s+/g, '')
    }

    return query
  }
}
